import React, { useState } from 'react';
import { Text } from '@radix-ui/themes';
import 'tailwindcss/tailwind.css';
import '@radix-ui/themes/styles.css';
import roleplayIcon from '../../../../assets/images/roleplay.png'; // Adjust path as needed
import plusSquareIcon from '../../../../assets/images/plussquare.png'; // Adjust path as needed
import maximizeIcon from '../../../../assets/images/maximize.png'; // Adjust path as needed
import minusIcon from '../../../../assets/images/minus.png'; // Adjust path as needed
import micIcon from '../../../../assets/images/mico.png';
import { RootState } from 'store';
import { useSelector } from 'react-redux';
import { User } from 'models/User';
import MyPeerView from 'components/classroom/components/Peers/MyPeerView';

const RpPresentationRankOrder = ({ showButton, onPress, groupName, presentationRank }) => {
    const [isUsersDragableCompOpen, setIsUsersDragableCompOpen] = useState(false);
    const [isExpandedTabel, setIsExpandedTabel] = useState(false);
    const profileData = useSelector((state: RootState) => state?.auth?.user as User);
    // const batchData = useSelector((state: any) => state?.session?.sessionData?.batch?.participants);
    const batchData = useSelector((state: RootState) => state.live.settings?.batch.participants);

    return (
        <div className="h-full flex justify-center">
            {/* <div className="absolute top-[-13vh] w-full flex justify-center items-center z-[999]">
                <div className="bg-[rgba(33,32,37,0.8)] w-[55vw] rounded-[1vh] py-[1vh] px-[4vw] border-[1px] border-[rgba(84,84,85,1)] flex items-center justify-center">
                    <Text
                        as="span"
                        size="2"
                        weight="bold"
                        className="text-[rgba(233,190,80,1)]"
                    >
                        Role Play debrief in progress
                    </Text>
                    <div className="w-[3vw]" />
                    <div className="h-[1.1vh] w-[1.1vh] rounded-full bg-[rgba(67,160,71,1)] border-[1px] border-[rgba(233,190,80,1)]" />
                </div>
            </div> */}

            {/* <div className="bg-[rgba(241,243,255,1)] flex items-center justify-center w-[80vw] rounded-[3vh] -mt-[20%]">
                <div className="absolute -top-[7.5vh] h-[15vh] w-[15vh] flex items-center justify-center rounded-full bg-[rgba(233,190,80,1)] border-[2px] border-white overflow-hidden">
                    <img
                        src={roleplayIcon}
                        alt="Roleplay"
                        className="h-[8vh] w-[8vh] object-contain"
                    />
                </div>
                <Text
                    as="span"
                    size="4"
                    className="text-black py-[1.5vh] font-[Lato-Regular] text-center w-[60vw] mb-[1vh] mt-[9vh] whitespace-pre-line"
                >
                    Your group {groupName} will present{'\n'}Order of presentation #{Number(presentationRank) + 1}
                </Text>
                {showButton && (
                    <button
                        onClick={onPress}
                        className="bg-[rgba(67,160,71,1)] rounded-[2.5vh] flex items-center justify-center h-[5vh] px-[7vw] mb-[3vh] shadow-md"
                    >
                        <Text
                            as="span"
                            size="3"
                            className="text-white font-[Lato-Regular] text-center"
                        >
                            OK
                        </Text>
                    </button>
                )}
            </div> */}

            <div className="w-full flex justify-center">
                <div className="bg-[#24272C] relative w-[30rem] largescreen:h-64 max-w-[536px] mobile:max-w-[90%] mobile:w-80  mobile:h-48 tablet:h-64 laptop:h-72 desktop:h-72 bg-gray-800 rounded-2xl flex flex-col items-center justify-center shadow-lg">
                    {/* SVG at top-left */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none"className="absolute top-2 left-2 mobile:w-[40px] mobile:h-[40px] tablet:w-[40px] tablet:h-[40px] laptop:w-[50px] laptop:h-[50px] desktop:w-[57px] desktop:h-[57px]">
                        <mask id="mask0_6083_19462" maskUnits="userSpaceOnUse" x="0" y="0" width="72" height="72">
                            <rect width="72" height="72" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_6083_19462)">
                            <path d="M63 63V15H9V39H3V15C3 13.35 3.5875 11.9375 4.7625 10.7625C5.9375 9.5875 7.35 9 9 9H63C64.65 9 66.0625 9.5875 67.2375 10.7625C68.4125 11.9375 69 13.35 69 15V57C69 58.65 68.4125 60.0625 67.2375 61.2375C66.0625 62.4125 64.65 63 63 63ZM27 42C23.7 42 20.875 40.825 18.525 38.475C16.175 36.125 15 33.3 15 30C15 26.7 16.175 23.875 18.525 21.525C20.875 19.175 23.7 18 27 18C30.3 18 33.125 19.175 35.475 21.525C37.825 23.875 39 26.7 39 30C39 33.3 37.825 36.125 35.475 38.475C33.125 40.825 30.3 42 27 42ZM27 36C28.65 36 30.0625 35.4125 31.2375 34.2375C32.4125 33.0625 33 31.65 33 30C33 28.35 32.4125 26.9375 31.2375 25.7625C30.0625 24.5875 28.65 24 27 24C25.35 24 23.9375 24.5875 22.7625 25.7625C21.5875 26.9375 21 28.35 21 30C21 31.65 21.5875 33.0625 22.7625 34.2375C23.9375 35.4125 25.35 36 27 36ZM3 66V57.6C3 55.9 3.4375 54.3375 4.3125 52.9125C5.1875 51.4875 6.35 50.4 7.8 49.65C10.9 48.1 14.05 46.9375 17.25 46.1625C20.45 45.3875 23.7 45 27 45C30.3 45 33.55 45.3875 36.75 46.1625C39.95 46.9375 43.1 48.1 46.2 49.65C47.65 50.4 48.8125 51.4875 49.6875 52.9125C50.5625 54.3375 51 55.9 51 57.6V66H3ZM9 60H45V57.6C45 57.05 44.8625 56.55 44.5875 56.1C44.3125 55.65 43.95 55.3 43.5 55.05C40.8 53.7 38.075 52.6875 35.325 52.0125C32.575 51.3375 29.8 51 27 51C24.2 51 21.425 51.3375 18.675 52.0125C15.925 52.6875 13.2 53.7 10.5 55.05C10.05 55.3 9.6875 55.65 9.4125 56.1C9.1375 56.55 9 57.05 9 57.6V60Z" fill="white" />
                        </g>
                    </svg>

                    {/* Centered content */}
                    <div className="mobile:p-3 mobile:mt-5 max-w-[300px] flex flex-col items-center justify-center space-y-2 mobile:space-y-1 tablet:space-y-2 laptop:space-y-3 desktop:space-y-4">
                        <Text
                            as="span"
                            size="4"
                            weight="bold"
                            className="text-white text-[14px] font-[Lato-Bold] largescreen:text-[14px] text-center mobile:text-xs tablet:text-sm laptop:text-sm desktop:text-xl"
                        >
                            Your group {groupName} will present{'\n'}Order of presentation #{Number(presentationRank) + 1}
                        </Text>
                        <button
                            onClick={onPress}
                            className="bg-[#7056A1] py-2 px-4 rounded-lg mx-2 my-1 mobile:py-1 mobile:px-3 tablet:py-2 tablet:px-4 laptop:py-2 laptop:px-5 desktop:py-3 desktop:px-6"
                        >
                            <Text
                                as="span"
                                size="5"
                                weight="bold"
                                className="text-white font-[Lato-Bold] mobile:text-sm tablet:text-base laptop:text-lg desktop:text-xl"
                            >
                                ok
                            </Text>
                        </button>
                        {/* <Text
                            as="span"
                            size="3"
                            className="text-white text-[10px] font-[Lato-Italic] px-4 text-center mobile:text-xs tablet:text-sm laptop:text-base desktop:text-lg"
                        >
                            You will need to keep your camera and audio enabled for the best outcome & experience
                        </Text> */}
                    </div>
                </div>
            </div>

            {/* {!isExpandedTabel && isUsersDragableCompOpen ? (
                <div className="flex items-center bg-[rgba(84,84,85,0.8)] h-[4.5vh] w-[50vw] absolute bottom-[-100px] right-[5vw] z-[999] px-[2vw]">
                    <button onClick={() => setIsUsersDragableCompOpen(true)} className="pr-[3vw]">
                        <img
                            src={plusSquareIcon}
                            alt="Plus"
                            className="h-[120%] w-[120%] object-contain"
                        />
                    </button>
                    <button onClick={() => setIsUsersDragableCompOpen(true)}>
                        <img
                            src={maximizeIcon}
                            alt="Maximize"
                            className="h-[2.5vh] w-[2.5vh] object-contain"
                        />
                    </button>
                    <span className="flex-1" />
                    <button onClick={() => { }}>
                        <img
                            src={micIcon}
                            alt="Mic"
                            className="h-[90%] w-[90%] object-contain"
                        />
                    </button>
                </div>
            ) : (
                !isExpandedTabel && (
                    <div className="flex flex-col items-center bg-[rgba(84,84,85,0.8)] h-[24.5vh] w-[40vw] z-[999] rounded-[1vh] overflow-hidden bottom-[-7%] ml-[28vh]">
                        <div>
                            <MyPeerView
                                style={{ height: '22vh', width: '40vw' }}
                                draggable={false}
                                x={0}
                                y={0}
                            />
                        </div>
                        <div className="flex items-center justify-center h-[3vh] w-[40vw]">
                            <Text
                                as="span"
                                size="3"
                                className="text-white w-[33vw] text-center"
                            >
                                {profileData?.name}
                            </Text>
                            <button onClick={() => { }}>
                                <img
                                    src={micIcon}
                                    alt="Mic"
                                    className="h-[60%] w-[60%] object-contain"
                                />
                            </button>
                        </div>
                        <div className="flex items-center justify-between px-[2vw] w-[40vw] mt-[1vh]">
                            <button onClick={() => setIsUsersDragableCompOpen(false)}>
                                <img
                                    src={minusIcon}
                                    alt="Minus"
                                    className="h-[110%] w-[110%] object-contain"
                                />
                            </button>
                            <button onClick={() => setIsUsersDragableCompOpen(false)}>
                                <img
                                    src={maximizeIcon}
                                    alt="Maximize"
                                    className="h-[120%] w-[120%] object-contain"
                                />
                            </button>
                        </div>
                    </div>
                )
            )} */}
        </div>
    );
};

export default RpPresentationRankOrder;